import React from 'react';
import { usePlanCheck } from '../hooks/usePlanCheck';
import Pricing from '../pages/Pricing';
import { Spinner } from '@shopify/polaris';

export const PlanGuard = ({ children }) => {
  const { hasPlan, isChecking } = usePlanCheck();

  if (isChecking) {
    return (
      <div style={{ textAlign: "center", paddingTop: "20%" }}>
        <Spinner accessibilityLabel="Loading" size="large" />
      </div>
    );
  }

  if (!hasPlan) {
    return <Pricing />;
  }

  return children;
};
